import Vue from 'vue';
import {
  Button,
  Cell,
  CellGroup,
  Dialog,
  Divider,
  Empty,
  Field,
  Form,
  Icon,
  List,
  Loading,
  NavBar,
  NoticeBar,
  Picker,
  Popup,
  PullRefresh,
  Step,
  Steps,
  Tab,
  Tabbar,
  TabbarItem,
  Tabs,
  Tag,
  Toast
} from 'vant';
import 'vant/lib/index.css';
import App from './App.vue';
import i18n from './i18n';
import router from './router';
import './styles/app.less';
import './styles/referral.less';

Vue.config.productionTip = false;

[
  Dialog,
  Button,
  Cell,
  CellGroup,
  Divider,
  Empty,
  Field,
  Form,
  Icon,
  List,
  Loading,
  NavBar,
  NoticeBar,
  Picker,
  Popup,
  PullRefresh,
  Step,
  Steps,
  Tab,
  Tabbar,
  TabbarItem,
  Tabs,
  Tag
].forEach((plugin) => Vue.use(plugin));

Vue.prototype.$toast = Toast;
Vue.prototype.$dialog = Dialog;

new Vue({
  i18n,
  router,
  render: (h) => h(App)
}).$mount('#app');
